const H5PBlanks = (attempt, parameters) => {
	const answers = JSON.parse(attempt.h5p_response.answer) || [];
	parameters = JSON.parse(parameters) || {};

	let answerIndex = 0;
	const areAnswersHidden = parameters.questions[0]?.includes("**");

	const generateAnswerBox = (userAnswer, placeholderOptions, areAnswersHidden) => {
		const { answer = "", correct = false } = userAnswer;

		const answerClass = correct ? "correct" : "incorrect";
		const iconClass = correct ? "pb-heroicons-solid_check" : "pb-heroicons-solid_x-mark";

		return `
            <span class="box ${answerClass}" tabindex="0">
                <i class="icon ${answerClass}-icon pb-heroicons ${iconClass}"></i>
                ${answer}
            </span>
            ${!areAnswersHidden ? `<span class="box correct-answer">${placeholderOptions.join(' / ')}</span>` : ''}
        `;
	};

	const processedQuestions = parameters.questions.map((question) => {
		return `<div class="question">${
			question.replace(/\*(.*?)\*/g, (_, word) => {
				const placeholderOptions = word.split("/");
				const userAnswer = answers[answerIndex++] || { answer: "", correct: false };
				return generateAnswerBox(userAnswer, placeholderOptions, areAnswersHidden);
			})
		}</div>`;
	});

	return `
        <div class="h5p-blanks">
            ${processedQuestions.join("")}
            <div class="explanation">
                ${!areAnswersHidden ? `<div class="box correct-answer-placeholder">Correct Answer</div>` : ""}
                <div class="box user-correct-answer">
                    <i class="icon correct-icon pb-heroicons pb-heroicons-solid_check"></i>
                    User's correct answer
                </div>
                <div class="box user-incorrect-answer">
                    <i class="icon incorrect-icon pb-heroicons pb-heroicons-solid_x-mark"></i>
                    User's incorrect answer
                </div>
            </div>
        </div>
    `;
};

export default H5PBlanks;
